import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  categoryNavItem: {
    '&:last-child': {
      [theme.breakpoints.up('sm')]: {
        marginBottom: '6rem',
      },
    },
    '&:nth-child(4)': {
      marginBottom: '3rem',
      [theme.breakpoints.up('sm')]: {
        marginBottom: '6rem',
      },
    },
    marginBottom: '1rem',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '2rem',
    },
  },
  categoryNavItemSelected: ({ categoryId }) => ({
    borderLeft: `12px solid rgb(var(--${categoryId}_rgb))`,
    borderRight: `12px solid rgb(var(--${categoryId}_rgb))`,
  }),
  categoryNavLink: ({ categoryId }) => ({
    '&::after': {
      right: 0,
    },
    '&::before': {
      left: 0,
    },
    '&::before, &::after': {
      background: 'transparent',
      content: "''",
      display: 'block',
      height: '64px',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '12px',
    },
    '&:hover, &:focus': {
      color: `rgb(var(--${categoryId}_rgb))`,
    },
    color: `rgb(${theme.palette.dustyGray})`,
    display: 'block',
    fontSize: '1.3rem',
    letterSpacing: '0.1em',
    position: 'relative',
    textDecoration: 'none',
    textTransform: 'uppercase',
    [theme.breakpoints.up('sm')]: {
      fontSize: '3rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '3.5rem',
    },
  }),
  categoryNavLinkSelected: ({ categoryId }) => ({
    color: `rgb(var(--${categoryId}_rgb))`,
  }),
}))

export default useStyles
